"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "salerano-sul-lambro": {
    "6558610b": [{
      "hkey": "be987736",
      "slug": "salerano-sul-lambro",
      "name": "Salerano sul Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "canovette": [{
      "hkey": "be987736",
      "slug": "salerano-sul-lambro",
      "name": "Salerano sul Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0959353": [{
      "hkey": "be987736",
      "slug": "salerano-sul-lambro",
      "name": "Salerano sul Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-ghione": [{
      "hkey": "be987736",
      "slug": "salerano-sul-lambro",
      "name": "Salerano sul Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;